// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  Messaging,
} from "firebase/messaging";
import {
  getFirestore,
  collection,
  getDoc,
  addDoc,
  getDocs,
  setDoc,
  updateDoc,
  onSnapshot,
  doc,
  serverTimestamp,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebaseConfig from "@/firebase/config";

const isBrowserSupported = "serviceWorker" in navigator;

// Initialize Firebase
const firebaseaApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseaApp);
const firestoreDB = getFirestore(firebaseaApp);
const messaging = isBrowserSupported
  ? getMessaging(firebaseaApp)
  : ({} as Messaging);

export {
  firebaseConfig,
  firestoreDB,
  firebaseaApp,
  messaging,
  getToken,
  onMessage,
  isSupported,
  collection,
  getDoc,
  addDoc,
  getDocs,
  setDoc,
  updateDoc,
  onSnapshot,
  doc,
  serverTimestamp,
  orderBy,
  query,
  where,
  ref,
  getStorage,
  uploadBytes,
  getDownloadURL,
};
